export default __webpack_public_path__ + "/public/microfrontends_configuration.png";